export const SET_LOADING_DATA = '@bonificationProduct/SET_LOADING_DATA';
export const SET_LOADING_SEND = '@bonificationProduct/SET_LOADING_SEND';
export const SET_LOADING_SELECTS = '@bonificationProduct/SET_LOADING_SELECTS';

export const GET_LIST_BONIFICATION_PRODUCT_REQUEST = '@bonificationProduct/GET_LIST_BONIFICATION_PRODUCT_REQUEST';
export const GET_LIST_BONIFICATION_PRODUCT_SUCCESS = '@bonificationProduct/GET_LIST_BONIFICATION_PRODUCT_SUCCESS';

export const GET_SELECTS_SUCCESS = '@bonificationProduct/GET_SELECTS_SUCCESS';

export const GET_BY_ID_REQUEST = '@bonificationProduct/GET_BY_ID_REQUEST';
export const GET_BY_ID_SUCCESS = '@bonificationProduct/GET_BY_ID_SUCCESS';

export const EDIT_ITEM = '@bonificationProduct/EDIT_ITEM';
export const DELETE_ITEM = '@bonificationProduct/DELETE_ITEM';

export const GET_PRODUCTS_REQUEST = '@bonificationProduct/GET_PRODUCTS_REQUEST';
export const GET_PRODUCTS_SUCCESS = '@bonificationProduct/GET_PRODUCTS_SUCCESS';

export const SAVE_BONIFICATION_PRODUCT_REQUEST = '@bonificationProduct/SAVE_BONIFICATION_PRODUCT_REQUEST';
export const SAVE_BONIFICATION_PRODUCT_SUCCESS = '@bonificationProduct/SAVE_BONIFICATION_PRODUCT_SUCCESS';

export const SET_PAGE = '@bonificationProduct/SET_PAGE';
export const SET_ROWS_COUNT = '@bonificationProduct/SET_ROWS_COUNT';
export const SET_ROWS_PER_PAGE = '@bonificationProduct/SET_ROWS_PER_PAGE';
export const SET_ORDER = '@bonificationProduct/SET_ORDER';
export const SET_ORDERBY = '@bonificationProduct/SET_ORDERBY';

export const SEARCH = '@bonificationProduct/SEARCH';
